import { GlobalComposable } from "~/classes/composable/GlobalComposable"

class UndoHistory extends GlobalComposable {
  undoLastAction = async () => {
    if (isDesktop())
      return await useTauri().sendUndoCommand()
    else return useCache().sendUndoCommand()
  }

  redoLastAction = async () => {
    if (isDesktop())
      return await useTauri().sendRedoCommand()
    else return useCache().sendRedoCommand()
  }
}

const undoHistory = new UndoHistory("undo-history", theme.colors.orange.hex)
export default function () {
  return undoHistory.use()
}
